export var config = {
  onError: function onError(e) {
    return console.error(e);
  }
};
export var setConfig = function setConfig(conf) {
  Object.assign(config, conf);
};